/**
 * English.
 *
 * Keys come from `cs.js`. A missing key falls back to Czech, so a gap shows up
 * as Czech text rather than as an empty space.
 */
const en = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Back',
  'obecne.hledat': 'Search',
  'obecne.nacitani': 'Loading…',
  'obecne.zrusit': 'Cancel',
  'obecne.ulozit': 'Save',
  'obecne.odeslat': 'Send',
  'obecne.vice': 'Show all',
  'obecne.jazyk': 'Language',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'A safe space for the trans community where you can speak openly, look for help and feel supported.',
  'auth.prihlaseni': 'Sign in',
  'auth.registrace': 'Sign up',
  'auth.email': 'Email',
  'auth.heslo': 'Password',
  'auth.emailPriklad': 'you@example.com',
  'auth.prihlasitSe': 'Sign in',
  'auth.prihlasuji': 'Signing in…',
  'auth.zapomenuteHeslo': 'Forgot your password?',
  'auth.presGoogle': 'Sign in with Google',
  'auth.spatneUdaje': 'Incorrect email or password',
  'auth.uspech': 'Signed in.',
  'auth.googleChyba': 'Signing in with Google failed',
  'auth.obnoveniHesla': 'Password reset',
  'auth.obnoveniOdeslano': 'If the email is registered, you will receive a password reset link.',
  'auth.zpetNaPrihlaseni': 'Back to sign in',
  'auth.odeslatOdkaz': 'Send reset link',
  'auth.obnoveniChyba': 'The email could not be sent. Please try again.',

  // druhý krok přihlášení
  'auth.jesteKod': 'One more step: your code',
  'auth.jesteKodPopis': 'Open your authenticator app and copy the six digits shown for Bloom.',
  'auth.kod': 'Code',
  'auth.zalozniKodNapoveda': 'No phone at hand? Enter one of the backup codes you saved when you turned this on.',
  'auth.potvrdit': 'Confirm',
  'auth.overuji': 'Checking…',
  'auth.kodNesedi': 'That code is not right',
  'auth.zalozniDochazeji': (p) => `You have only ${p.pocet} backup codes left. Generate new ones in your profile.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'How to install Bloom on your phone',
  'auth.krokyAndroid': [
      'Open this page in Chrome',
      'Tap the three-dot icon (⋮) in the top right corner',
      'Choose “Add to Home screen” or “Install app”',
      'Confirm the installation',
    ],
  'auth.krokyIos': [
      'Open this page in Safari',
      'Tap the share icon (□↑) in the bottom bar',
      'Scroll down and choose “Add to Home Screen”',
      'Confirm by tapping “Add”',
    ],
  'auth.seznamChranene': [
      { silne: 'Nothing about members is public.', text: 'Profiles, stories, offers, questions, photos and avatars are served only to signed-in people. None of it can be downloaded or harvested without an account.' },
      { silne: 'Nobody knows your password', text: '— not even us. It is stored as a bcrypt hash, from which the original cannot be recovered.' },
      { silne: 'Private messages and attachments are encrypted', text: '(AES + integrity check) on the server\'s disk. Anyone who obtained a backup or the disk would read only meaningless characters.' },
      { silne: 'Messages delete themselves', text: 'after a set period (90 days by default), including voice notes and photos. What is not here cannot leak.' },
      { silne: 'Your transition stage is private', text: 'until you publish it yourself. Nobody else sees the steps you tick off in the Guide.' },
      { silne: 'Email and phone', text: 'are never shown to other members.' },
      { silne: '', text: 'Sign-in is protected against password guessing by limiting the number of attempts.' },
      { silne: 'End-to-end encryption of messages.', text: 'When you turn it on, text and attachments are encrypted in your own browser and the server receives only gibberish. The key is unlocked by your password and never leaves your device — so we cannot read the content either, not even if a court asked. The price is that if you forget your password, you cannot read old messages either.' },
      { silne: '', text: 'Being signed in does not persist: Bloom signs you out when you close the window and after ten minutes of inactivity.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Metadata', text: '— who wrote to whom and when — must be known to the server so it can deliver the message. End-to-end encryption does not hide this, and neither does Signal.' },
      { silne: '', text: 'Bloom is a web app, so it downloads its encryption code from our server every time you open it. Anyone who took over the server could in theory serve modified code. Only a signed app from a store protects against that — which is why Signal has one and a web version does not.' },
      { silne: 'Profiles', text: '— nickname, bio, avatar — cannot be encrypted, because the server has to show them to other members.' },
      { silne: '', text: 'Messages from before you turned encryption on stay encrypted only on the server\'s disk, not end-to-end.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom works like an app, even offline. Your data is always up to date.',
  'auth.zabezpeceniTitulek': 'How Bloom is secured',
  'auth.zabezpeceniUvod': 'Bloom is a space for the trans community, so sensitive things meet here. Below is what we '
      + 'do to protect them — and what we cannot do — without sugar-coating.',
  'auth.coJeChranene': 'What is protected',
  'auth.coNeumime': 'What Bloom cannot do — and it is fair to say so',
  'auth.zabezpeceniZaver': 'If you have a question about privacy or you found a weakness, use “Report a problem” below. We take it seriously.',
  'auth.mvp': 'Bloom is in its first version and we keep improving it together with the community. '
      + 'If you hit a bug or have an idea, we would be glad to hear it.',
  'auth.nahlasitProblem': 'Report a problem',
  'auth.clenu': (p) => (p.pocet === 1 ? 'member' : 'members'),
  'auth.prispevku': (p) => (p.pocet === 1 ? 'post' : 'posts'),
  'auth.odborniku': (p) => (p.pocet === 1 ? 'professional' : 'professionals'),
  'auth.nabidek': (p) => (p.pocet === 1 ? 'offer' : 'offers'),

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Nickname (unique)',
  'reg.prezdivkaPriklad': 'At least 3 characters',
  'reg.telefon': 'Phone number',
  'reg.volitelne': '(optional)',
  'reg.heslo': 'Password',
  'reg.hesloZnovu': 'Repeat password',
  'reg.zajmeno': 'Pronouns',
  'reg.oMne': 'About me',
  'reg.oMnePriklad': 'A few words about you…',
  'reg.registrovat': 'Create account',
  'reg.registruji': 'Creating account…',
  'reg.presGoogle': 'Sign up with Google',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'Or upload your own photo',
  'reg.nahratFoto': 'Upload photo',
  'reg.vlastni': 'Custom',
  'reg.zeme': 'Country',
  'reg.kraj': 'Region',
  'reg.nechciUvadet': 'Prefer not to say',
  'reg.cesko': 'Czech Republic',
  'reg.svet': 'Rest of the world',

  // skupiny avatarů
  'reg.avatarFem': 'Feminine',
  'reg.avatarMask': 'Masculine',
  'reg.avatarNeutr': 'Neutral',
  'reg.avatarZvirata': 'Animals',

  // komunitní heslo
  'reg.komunitniHeslo': 'Community password',
  'reg.komunitniHesloPriklad': 'Enter the community password…',
  'reg.komunitniHesloPopis': 'Bloom is a private space for the trans community. Someone from the community can give you the password.',
  'reg.napisAdminovi': 'If you do not know anyone, write to the admin at',
  'reg.nevimHeslo': 'I do not know the community password',
  'reg.jakZiskat': 'The community password protects this private space. How to get it:',
  'reg.krok1': '1. Write an email to',
  'reg.krok2': '2. Introduce yourself briefly and say how you heard about Bloom',
  'reg.krok3': '3. The administrator will reply as soon as possible',

  // kontrola hesla
  'reg.hesloKratke': 'The password must be at least 8 characters',
  'reg.hesloMale': 'The password must contain a lower-case letter',
  'reg.hesloVelke': 'The password must contain an upper-case letter',
  'reg.hesloCislo': 'The password must contain a digit',
  'reg.hesloZnak': 'The password must contain a special character (!@#$%…)',
  'reg.pozadavek8': 'At least 8 characters',
  'reg.pozadavekVelke': 'Upper-case letter',
  'reg.pozadavekCislo': 'Digit',
  'reg.pozadavekZnak': 'Special character (!@#$%)',
  'reg.hesloNesouhlasi': 'The passwords do not match',
  'reg.prezdivkaKratka': 'The nickname must be at least 3 characters',
  'reg.hesloPovinne': 'The community password is required',
  'reg.hotovo': 'Account created. Please check your email to verify it.',
  'reg.fotoVelka': 'The image is too large (max 2 MB)',
  'reg.chyba': 'Sign-up failed',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Nobody here has to be perfect. Bloom is a space where everyone can be themselves — '
      + 'where you can share your experience, ask questions and help others. Without judgement and without prejudice.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · translated from Czech',
  'domu.vitej': 'Welcome,',
  'domu.vCislech': 'Bloom in numbers',
  'domu.noveVKomunite': 'New here?',
  'domu.noveVKomunitePopis1': 'You do not have to be visible. You do not need a photo. You do not have to be out.',
  'domu.noveVKomunitePopis2': 'Bloom is a space where you can start at your own pace.',
  'domu.rozcestnik1': 'It is my first time here',
  'domu.rozcestnik2': 'I do not know where to start',
  'domu.rozcestnik3': 'I want to stay anonymous',
  'domu.rozcestnik4': 'I am looking for a professional',
  'domu.rozcestnik5': 'I just want to read others\' stories',
  'domu.otazky': 'Questions, or want to know more? Write to us at',
  'domu.doporucujeme': 'Recommended',
  'domu.odbornici': 'Professionals',
  'domu.noviClenove': 'New community members',
  'domu.zadniNovi': 'No new members yet',
  'domu.nejnovejsiOtazky': 'Latest questions',
  'domu.zadneOtazky': 'No questions yet.',
  'domu.nejlepeHodnoceni': 'Top-rated professionals',
  'domu.zadniHodnoceni': 'No rated professionals yet',
  'domu.zadneAktuality': 'No news yet',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Offer your skills and get help from others.',
  'domu.dlazdice.specialists': 'Find verified professionals, from psychologists to plastic surgeons.',
  'domu.dlazdice.legal': 'Legal help, articles and answers to your questions.',
  'domu.dlazdice.nearby': 'Services and professionals near you.',

  // počty
  'domu.pocetClenu': (p) => (p.pocet === 1 ? 'community member' : 'community members'),
  'domu.pocetZkusenosti': (p) => (p.pocet === 1 ? 'shared story' : 'shared stories'),
  'domu.pocetOdborniku': (p) => (p.pocet === 1 ? 'verified professional' : 'verified professionals'),
  'domu.pocetNabidek': (p) => (p.pocet === 1 ? 'peer-support offer' : 'peer-support offers'),

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Home',
  'nav.news': 'News',
  'nav.stories': 'Community stories',
  'nav.mapaSveta': 'World map',
  'nav.support': 'Peer support',
  'nav.specialists': 'Trans-friendly professionals',
  'nav.legal': 'Legal help',
  'nav.pageants': 'Pageants',
  'nav.nearby': 'Near me',
  'nav.hledat': 'Search Bloom',
  'nav.hledatPlaceholder': 'Search people, professionals, articles…',
  'nav.zpravy': 'Messages',
  'nav.profil': 'My profile',
  'nav.mojeCesta': 'My journey',
  'nav.administrace': 'Administration',
  'nav.odhlasit': 'Log out',
  'nav.vsechnyVysledky': (p) => `Show all results for “${p.dotaz}”`,
  'nav.overEmail': 'Verify your email',
  'nav.menu': 'Menu',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom around the world',
  'svet.podtitulek': 'Pick a country and see what the community has gathered there.',
  'svet.hledatZemi': 'Search for a country…',
  'svet.vsechnyZeme': 'All countries',
  'svet.jenSObsahem': 'Only countries with content',
  'svet.nicNenalezeno': 'No country matches.',
  'svet.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entry' : 'entries'}`,
  'svet.prazdnaZeme': 'Nothing yet',
  'svet.kontinent': 'Continent',
  'svet.celySvet': 'Whole world',
  'svet.vse': 'Everything',
  'svet.zacniDomovem': 'Start by picking the country you call home. You can also choose from the list below the map.',
  'svet.zkoumej': 'Pick a country and see what Bloom has there. Browse anywhere you like — '
      + 'it will not change your home country.',
  'svet.domov': 'Home',
  'svet.zrusitDomov': 'Clear home country',
  'svet.nastavitDomov': 'Set as home country',
  'svet.zeSveta': 'Around the world',
  'svet.coSeChysta': 'Coming up',
  'svet.souteze': 'Pageants with open registration',
  'svet.noveOrganizace': 'New organisations',
  'svet.kdeJizNeco': 'Where Bloom already has something',
  'svet.hledatZemiPopisek': 'Search for a country',
  'svet.nicNeodpovida': 'Nothing matches. Try a different search.',
  'svet.napovedaKMape': 'Drag the map to move it and zoom with the wheel or the buttons. You do not '
      + 'have to use it — search and the full list of countries are below.',
  'svet.tvujBloom': (p) => `Your Bloom in ${p.zeme}`,
  'svet.tvojeDomovska': 'your home country',
  'svet.zemi': (p) => `${p.pocet} ${p.pocet === 1 ? 'country' : 'countries'}`,
  'svet.chyba': 'Countries could not be loaded. Please reload the page.',
  'svet.pocet.specialists': (p) => `${p.pocet} ${p.pocet === 1 ? 'professional' : 'professionals'}`,
  'svet.pocet.organizations': (p) => `${p.pocet} ${p.pocet === 1 ? 'organisation' : 'organisations'}`,
  'svet.pocet.events': (p) => `${p.pocet} ${p.pocet === 1 ? 'event' : 'events'}`,
  'svet.pocet.pageants': (p) => `${p.pocet} ${p.pocet === 1 ? 'pageant' : 'pageants'}`,
  'svet.pocet.resources': (p) => `${p.pocet} ${p.pocet === 1 ? 'resource' : 'resources'}`,

  // světadíly
  'kontinent.europe': 'Europe',
  'kontinent.asia': 'Asia',
  'kontinent.africa': 'Africa',
  'kontinent.north_america': 'North America',
  'kontinent.south_america': 'South America',
  'kontinent.oceania': 'Oceania',
  'kontinent.antarctica': 'Antarctica',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Trans pageants from around the world. The ones you can still enter are at the top.',
  'souteze.hledat': 'Search for a pageant…',
  'souteze.zadne': 'We have no pageants yet. Do you know one? Send a suggestion.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Open ${p.zeme}`,
  'nahled.zavrit': 'Close preview',
  'nahled.jenInformace': 'So far we only have information about the country.',
  'nahled.zatimNic': 'We have no contacts, organisations or events here yet. Know something? Send a suggestion.',

  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom in ${p.zeme}`,
  'zeme.podtitulek': (p) => `What the community has gathered in ${p.zeme}.`,
  'zeme.prazdna': 'Bloom is just starting here. You could be the first to add something.',
  'zeme.mapaSveta': 'World map',
  'zeme.navrhnout': 'Suggest an entry',
  'zeme.domovska': 'Your home country',
  'zeme.nastavitDomovskou': 'Set as home country',
  'zeme.kdeToJe': 'Where to find it',
  'zeme.coTuBude': 'What you will find here',
  'zeme.zatimPrazdne': 'empty so far',
  'zeme.pripravujeme': 'coming soon',
  'zeme.zobrazitVse': (p) => `Show all (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom is just growing here',
  'zeme.rostePopis': 'We have nothing here yet. Do you know an organisation, an event or a '
      + 'useful contact? Send a suggestion — it goes through review and then shows up here.',
  'zeme.jinouZemi': 'Browse other countries',
  'zeme.bezKontaktu': 'We have no contacts or organisations here yet.',
  'zeme.bezKontaktuPopis': 'Do you know someone or something useful here? Send a suggestion — it '
      + 'goes through review and then shows up here.',
  'zeme.neznama': 'We do not know that country.',
  'zeme.chyba': 'The country could not be loaded.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Doctors and clinics',
  'sekce.specialists.popis': 'Doctors, clinics and other professionals the community has experience with.',
  'sekce.organizations': 'Organisations',
  'sekce.organizations.popis': 'Associations, non-profits and support groups.',
  'sekce.events': 'Events',
  'sekce.events.popis': 'Meet-ups, Pride, workshops and conferences.',
  'sekce.pageants': 'Pageants',
  'sekce.pageants.popis': 'Trans pageants and their dates.',
  'sekce.resources': 'Resources',
  'sekce.resources.popis': 'Practical information for this country.',
  'sekce.community': 'Community',
  'sekce.community.popis': 'People and groups in this country.',
  'sekce.legal': 'Legal help',
  'sekce.legal.popis': 'Information and support for the trans community',
  'sekce.support': 'Peer support',
  'sekce.support.popis': 'Offer your skills and get help from other community members',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Search in this country…',
  'vypis.vsechnyKategorie': 'All categories',
  'vypis.kategorie': 'Category',
  'vypis.celaZeme': 'Whole country',
  'vypis.navrhnout': 'Suggest',
  'vypis.nicNeodpovida': 'Nothing matches. Try a different search or clear the filter.',
  'vypis.zadneZaznamy': (p) => `We have no entries in ${p.zeme} yet.`,
  'vypis.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entry' : 'entries'}`,
  'vypis.predchozi': 'Previous',
  'vypis.dalsi': 'Next',
  'vypis.chyba': 'Entries could not be loaded.',
  'vypis.neznamyDruh': 'We do not know that kind of entry.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Back to ${p.zeme}`,
  'detail.kontakty': 'Contacts and links',
  'detail.podrobnosti': 'Details',
  'detail.zacatek': 'Starts',
  'detail.termin': 'Date',
  'detail.uzaverka': 'Registration deadline',
  'detail.prihlaska': 'Registration',
  'detail.strankaAkce': 'Event page',
  'detail.web': 'Website',
  'detail.konec': 'Ends',
  'detail.stavRocniku': 'Edition status',
  'detail.oblasti': 'Areas of work',
  'detail.coNabizi': 'What they offer',
  'detail.kategorie': 'Categories',
  'detail.jazyky': 'Languages',
  'detail.vitezove': 'Previous winners',
  'detail.kdoSeMuze': 'Who can enter',
  'detail.poradatel': 'Organiser',
  'detail.poplatek': 'Fee',
  'detail.tema': 'Topic',
  'detail.forma.offline': 'In person',
  'detail.forma.online': 'Online',
  'detail.forma.hybrid': 'In person and online',
  'detail.rozsah.local': 'Local',
  'detail.rozsah.national': 'National',
  'detail.rozsah.international': 'International',
  'detail.rocnik.upcoming': 'Upcoming',
  'detail.rocnik.registration_open': 'Registration open',
  'detail.rocnik.registration_closed': 'Registration closed',
  'detail.rocnik.completed': 'Completed',
  'detail.zdroj': (p) => `Source: ${p.zdroj}`,
  'detail.upraveno': (p) => `Last updated: ${p.datum}`,
  'detail.overeno': 'Verified as accurate. This is not an endorsement by Bloom.',
  'detail.neovereno': 'This entry is not verified yet. Details may have changed — please check with the source.',
  'detail.nenalezen': 'We do not know that entry. It may have been deleted or is still awaiting review.',
  'detail.chyba': 'The entry could not be loaded.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'What applies here',
  'profil.name_change': 'Name change',
  'profil.gender_marker': 'Legal gender marker',
  'profil.surgery_required': 'Surgery requirement',
  'profil.healthcare': 'Access to healthcare',
  'profil.legal_protection': 'Anti-discrimination protection',
  'profil.safety': 'Safety',
  'profil.stav.yes': 'Yes',
  'profil.stav.limited': 'Partly',
  'profil.stav.no': 'No',
  'profil.stav.unknown': 'Unknown',
  'profil.zdroj': 'Source',
  'profil.zdrojZRoku': (p) => `source from ${p.rok}`,
  'profil.overeno': (p) => `Checked ${p.datum}`,
  'profil.zmena': 'Recent change',
  'profil.odKdy': (p) => `in force since ${p.datum}`,
  'profil.doklady': 'Sources',
  'profil.zakon': 'law or court',
  'profil.upozorneni': 'This is not legal advice. Laws change and much depends on your specific '
      + 'situation — please check with the source or with an organisation in that '
      + 'country before you act on it.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Suggest ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Your suggestion goes through review before it appears in Bloom. Fill in what '
      + 'you know — we will add the rest.',
  'navrh.jednotne.organizations': 'an organisation',
  'navrh.jednotne.events': 'an event',
  'navrh.jednotne.pageants': 'a pageant',
  'navrh.jednotne.resources': 'a resource',
  'navrh.popis.organizations': 'An association, a non-profit or a support group.',
  'navrh.popis.events': 'A meet-up, Pride, a workshop, a conference.',
  'navrh.popis.pageants': 'A trans pageant – date, registration, organiser.',
  'navrh.popis.resources': 'Practical information – healthcare, law, documents, contacts.',
  'navrh.nazev': 'Name',
  'navrh.popisPole': 'Description',
  'navrh.zeme': 'Country',
  'navrh.mesto': 'City',
  'navrh.adresa': 'Address',
  'navrh.web': 'Website',
  'navrh.email': 'Email',
  'navrh.telefon': 'Phone',
  'navrh.odkudVis': 'How do you know',
  'navrh.odkudVisPriklad': 'e.g. their website, I was there…',
  'navrh.vyberte': '— choose —',
  'navrh.forma': 'Format',
  'navrh.rozsah': 'Scope',
  'navrh.platiPro': 'Applies to',
  'navrh.platnost.global': 'Whole world',
  'navrh.platnost.country': 'A country',
  'navrh.platnost.region': 'A region',
  'navrh.platnost.city': 'A city',
  'navrh.odkazAkce': 'Event link',
  'navrh.odkazPrihlaska': 'Registration link',
  'navrh.odkazy': 'Links',
  'navrh.text': 'Text',
  'navrh.odeslat': 'Send suggestion',
  'navrh.odesilam': 'Sending…',
  'navrh.chyba': 'The suggestion could not be sent',
  'navrh.dikyTitulek': 'Thanks, we have it',
  'navrh.dikyPopis': 'We have received your suggestion. One of us will review it and then it will '
      + 'appear in Bloom. Nothing is published automatically.',
  'navrh.zavrit': 'Close',
  'navrh.seznamNapoveda': 'Separate items with commas.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `Is this ${p.druh} yours?`,
  'prevzeti.popis': 'You can take over the profile and keep the details up to date. '
      + 'The request goes through review first.',
  'prevzeti.tlacitko': 'Claim this profile',
  'prevzeti.spravujes': 'You manage this profile. You can correct the details any time — changes take effect immediately.',
  'prevzeti.upravit': 'Edit details',
  'prevzeti.spravujeSama': (p) => `This profile is managed by the ${p.druh} itself.`,
  'prevzeti.ceka': 'We have received your claim and are reviewing it.',
  'prevzeti.formulacTitulek': (p) => `Claim profile — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Before we hand the profile over, we need to know you really belong to the '
      + 'organisation. The request goes through review; nothing changes right away.',
  'prevzeti.role': 'What is your role there?',
  'prevzeti.rolePriklad': 'e.g. coordinator, chair of the association',
  'prevzeti.doklad': 'How can we verify that?',
  'prevzeti.dokladPriklad': 'e.g. I am listed on the organisation\'s website under contacts; or write from an official address',
  'prevzeti.dokladNapoveda': 'A link to a page where you are listed is enough, or the organisation\'s '
      + 'official address to write from.',
  'prevzeti.kontakt': 'Your contact',
  'prevzeti.kontaktPriklad': 'email or phone',
  'prevzeti.dalsi': 'Anything else',
  'prevzeti.nepovinne': '(optional)',
  'prevzeti.odeslat': 'Send request',
  'prevzeti.odesilam': 'Sending…',
  'prevzeti.vyplnObe': 'Please tell us your role and how it can be verified.',
  'prevzeti.prijato': 'Thank you. We have received your request and will get back to you.',
  'prevzeti.chyba': 'The request could not be sent.',
  'prevzeti.upravaTitulek': (p) => `Edit profile — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Name and location are deliberately not here: entries are searched and '
      + 'sorted by them. If they changed, write to us and we will update them.',
  'prevzeti.popisPole': 'Description',
  'prevzeti.email': 'Email',
  'prevzeti.telefon': 'Phone',
  'prevzeti.web': 'Website',
  'prevzeti.ulozeno': 'Saved.',
  'prevzeti.ukladam': 'Saving…',
  'prevzeti.chybaUlozeni': 'Saving failed.',
  'prevzeti.druh.organizations': 'organisation',
  'prevzeti.druh.events': 'event',
  'prevzeti.druh.pageants': 'pageant',
  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Edit your details and settings',
  'profil.overeny': 'Verified',
  'profil.neovereny': 'Not verified',
  'profil.overteEmail': 'Please verify your email. An unverified account has limited rights.',
  'profil.emailOdeslan': 'Verification email sent.',
  'profil.emailChyba': 'The email could not be sent',
  'profil.odeslano': 'Sent.',
  'profil.overeniOdbornika': 'Verification as a professional or lawyer',
  'profil.pracujeteVOboru': 'Do you work in the field? Get a verified badge.',
  'profil.zadostOdeslana': 'Request sent',
  'profil.pozadatOOvereni': 'Request verification',
  'profil.zadostTitulek': 'Request verification as a professional or lawyer',
  'profil.zadostPopis': 'Fill in the details of your request. Moderators will review it.',
  'profil.pozadovanaRole': 'Requested role',
  'profil.roleOdbornik': 'Professional',
  'profil.rolePravnik': 'Lawyer',
  'profil.specializace': 'Speciality',
  'profil.odkazNaProfil': 'Link to a professional profile',
  'profil.zpravaProAdmina': 'A short message for the admin',
  'profil.odesilam': 'Sending\u2026',
  'profil.odeslatZadost': 'Send verification request',
  'profil.vyplnteSpecializaci': 'Please fill in your speciality',
  'profil.zadostUspech': 'Your verification request has been sent.',
  'profil.zadostChyba': 'The request could not be sent',

  // bezpečnost
  'bezp.titulek': 'Security',
  'bezp.sifrovaniZapnuto': (p) => `Message encryption is on${p.odemceno ? ' and unlocked' : ' (locked in this tab)'}.`,
  'bezp.sifrovaniVypnuto': 'You do not have message encryption turned on yet.',
  'bezp.sifrovaniKde': 'You turn it on and unlock it on the Messages page.',
  'bezp.sifrovaniKdeVypnute': 'You can turn it on from the Messages page, in any conversation.',
  'bezp.zmenaHesla': 'Change password',
  'bezp.zmenaHeslaSifrovani': 'You have encryption on, so changing your password also re-wraps your message key. '
      + 'That is why the current password is needed \u2014 without it the key could not be opened and you would lose your messages.',
  'bezp.stavajiciHeslo': 'Current password',
  'bezp.noveHeslo': 'New password',
  'bezp.noveHesloZnovu': 'Repeat new password',
  'bezp.pozadavky': 'At least 8 characters, upper and lower case, a digit and one special character.',
  'bezp.zmenitHeslo': 'Change password',
  'bezp.menim': 'Changing\u2026',
  'bezp.hesloNeshoda': 'The new passwords do not match.',
  'bezp.vyplnObe': 'Please fill in both passwords.',
  'bezp.stareNesedi': 'The current password is not right \u2014 your message key would be lost, so nothing was changed.',
  'bezp.zmenenoSKlicem': 'Password changed. Your message key was re-wrapped, so old messages stay readable.',
  'bezp.zmeneno': 'Password changed.',
  'bezp.zmenaChyba': 'The password could not be changed.',
  'bezp.nepamatujes': 'Do not remember the key password?',
  'bezp.zahoditPopis': 'You can discard the key and start over. Messages encrypted so far will be lost for good '
      + '\u2014 nobody can read them, not even us. That is exactly why it is safe.',
  'bezp.zahodit': 'Discard keys and start over',
  'bezp.zahoditPotvrzeni': 'Really discard the keys?\n\nEvery message encrypted so far will be lost for good '
      + '\u2014 nobody can read them, not even us. Do this only if you do not remember the password '
      + 'you used when you turned encryption on.',
  'bezp.klicSmazan': 'Keys deleted. Please reload the page.',
  'bezp.nepovedlo': 'That did not work.',
  'bezp.prohlizecNeumi': 'This browser does not support the encryption Bloom uses.',

  'profil.mujProfil': 'My profile',
  'profil.specializacePriklad': 'e.g. psychologist, sexologist, lawyer…',
  'profil.zpravaPriklad': 'For example a link to your professional registration or practice website…',
  'profil.overeniUvod': 'Would you like to be a verified professional or lawyer on Bloom? Send a verification request. '
      + 'Your profile must match your actual profession.',

  'profil.oborPriklad': 'e.g. plastic surgery, family law…',
  'profil.nepovinnyText': 'Optional additional note…',

  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Two-factor sign-in',
  'dvf.zapnuto': (p) => `On. You have ${p.pocet} backup codes left.`,
  'dvf.vypnuto': 'On top of your password you also enter a six-digit code from an app on your phone.',
  'dvf.chraniA': 'It protects',
  'dvf.chraniPrihlaseni': 'signing in',
  'dvf.chraniB': ': someone who knows your password but does not have your phone cannot get in.',
  'dvf.nechrani': 'It does not protect encrypted messages',
  'dvf.nechraniPopis': ' \u2014 those are unlocked by your password in your own browser and the server is not involved.',
  'dvf.ulozKody': 'Save these ten backup codes',
  'dvf.ulozKodyPopis1': 'Each one works once, and they are the only way in if you lose your phone.',
  'dvf.znovuNeukaze': 'Nobody will show them to you again',
  'dvf.ulozKodyPopis2': ' \u2014 we only store their hashes.',
  'dvf.zkopirovat': 'Copy',
  'dvf.ulozilaJsem': 'I have saved them',
  'dvf.zkopirovano': 'Copied.',
  'dvf.kopieChyba': 'Copying failed, please write them down by hand.',
  'dvf.zapnout': 'Turn on two-factor sign-in',
  'dvf.pripravuji': 'Preparing\u2026',
  'dvf.nactiKod': 'Scan this code in an authenticator app \u2014 for example Google Authenticator, Authy, 1Password or Aegis.',
  'dvf.qrNejde': 'Cannot scan the QR code?',
  'dvf.zadejRucne': 'Enter this key in the app manually:',
  'dvf.opisKod': 'Enter the code shown in the app',
  'dvf.zapnoutKratce': 'Turn on',
  'dvf.overuji': 'Checking\u2026',
  'dvf.noveKody': 'New backup codes',
  'dvf.vypnout': 'Turn off',
  'dvf.noveKodyPopis': 'A new set replaces the old one \u2014 your current backup codes will stop working.',
  'dvf.kodZAplikace': 'Code from the app',
  'dvf.vygenerovat': 'Generate',
  'dvf.vypnutiPopis': 'Turning it off needs both your password and a valid code. Both on purpose: otherwise anyone with access to an unlocked browser could remove it.',
  'dvf.kodNeboZalozni': 'Code from the app or a backup code',
  'dvf.vypinam': 'Turning off\u2026',
  'dvf.vypnoutCele': 'Turn off two-factor sign-in',
  'dvf.vypnuto2': 'Two-factor sign-in turned off.',
  'dvf.kodNesedi': 'That code is not right.',
  'dvf.nepovedlo': 'That did not work.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Profile updated.',
  'pf.chyba': 'The profile could not be updated',
  'pf.fotkaNahrana': 'Photo uploaded.',
  'pf.fotkaChyba': 'The image could not be uploaded',
  'pf.fotkaVelka': 'The image is too large (max 5 MB)',
  'pf.oznameniUlozeno': 'Notification settings saved.',
  'pf.oznameniChyba': 'The settings could not be saved',
  'pf.zruseno': 'Your profile has been deleted',
  'pf.zruseniChyba': 'The profile could not be deleted',
  'pf.zruseniPotvrzeni': 'Do you really want to delete your profile? This cannot be undone and all your data will be erased.',
  'pf.urlFacebook': 'The Facebook URL must start with https://',
  'pf.urlInstagram': 'The Instagram URL must start with https://',
  'pf.urlLinkedin': 'The LinkedIn URL must start with https://',
  'pf.ukladam': 'Saving\u2026',
  'pf.ulozitOznameni': 'Save notification settings',
  'pf.oznameniZpravy': 'Direct messages',
  'pf.oznameniAdmin': 'New message from an administrator',
  'pf.oznameniUzivatel': 'New message from another member',
  'pf.oznameniPodpora': 'New post in Peer support',
  'pf.oznameniNabidky': 'Offers and requests',

  // odznaky
  'pf.odznakAdmin': 'Administrator',
  'pf.odznakPravnik': 'Lawyer',
  'pf.odznakSpecialista': 'Verified professional',
  'pf.odznakClen': 'Verified community member',
  'pf.odznakPomocnik': 'Active helper',
  'pf.odznakDuveryhodny': 'Trusted member',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Photo added to the gallery.',
  'gal.smazano': 'Photo deleted',
  'gal.hesloKratke': 'The gallery password must be at least 4 characters',
  'gal.nahraniChyba': 'The photo could not be uploaded',
  'gal.mazaniChyba': 'The photo could not be deleted',
  'gal.souborVelky': 'The file is too large (max 5 MB)',
  'gal.ulozitNastaveni': 'Save settings',
  'gal.soukromiGalerie': 'Gallery privacy',
  'gal.verejnaGalerie': 'Public gallery',
  'gal.hesloPopis': 'Visitors will have to enter this password to see the gallery.',
  'gal.pridat': 'Add a photo or video',
  'gal.prazdna': 'No photos in the gallery yet',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Where am I now?',
  'cesta.popis': 'Share your transition stage if you want \u2013 or keep it to yourself.',
  'cesta.soukroma': 'Your stage is private',
  'cesta.viditelna': 'Your stage is visible to others',
  'cesta.jenTy': 'Only you can see your stage',
  'cesta.mohouNajit': 'Others can find you through \u201cFind people at a similar stage\u201d',
  'cesta.poznamka': 'Personal note',
  'cesta.volitelna': '(optional)',
  'cesta.poznamkaPriklad': 'Anything you want to share or remember\u2026',
  'cesta.najitPodobne': 'Find people at a similar stage',
  'cesta.hledam': 'Searching\u2026',
  'cesta.ulozit': 'Save my journey',
  'cesta.ulozeno': 'Your journey has been saved.',
  'cesta.vyberteFazi': 'Please choose a stage',
  'cesta.chyba': 'Could not save',

  'pf.socialniSite': 'Social media',
  'pf.avatarFoto': 'Avatar / profile photo',
  'pf.nahratProfilni': 'Upload profile photo',
  'pf.zrusitProfil': 'Delete profile',
  'pf.nastaveniOznameni': 'Notification settings',
  'pf.nastaveniOznameniPopis': 'Choose which events you want push notifications for.',
  'gal.overEmail': 'To upload photos you first need to verify your email.',
  'cesta.coMeCeka': 'What is ahead',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Messages',
  'zpr.hledatUzivatele': 'Search for a member\u2026',
  'zpr.zadneKonverzace': 'No conversations yet',
  'zpr.vyhledejteVyse': 'Search for a member above',
  'zpr.vyberteKonverzaci': 'Pick a conversation or search for a member',
  'zpr.napisteZpravu': 'Write a message\u2026',
  'zpr.nahravam': 'Recording\u2026',
  'zpr.prilozitObrazek': 'Attach an image',
  'zpr.hlasovaZprava': 'Voice message',
  'zpr.zastavitNahravani': 'Stop recording',
  'zpr.obrazek': 'Image',
  'zpr.overteEmail': 'To send messages, verify your email.',
  'zpr.profil': 'Profile',

  // šifrování
  'zpr.sifrovanaZprava': 'Encrypted message',
  'zpr.odemkniNahore': 'Encrypted message \u2014 unlock your messages above.',
  'zpr.nelzeOtevrit': 'This encrypted message could not be opened.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Member not found',
  'zpr.prijemceNenalezen': 'Recipient not found',
  'zpr.prihlasteZnovu': 'Please sign in again (your session expired)',
  'zpr.serverNedostupny': 'Cannot reach the server. Check that the backend is running.',
  'zpr.chybaOdeslani': 'Sending failed',
  'zpr.souborVelky': 'The file is too large (max 5 MB)',
  'zpr.formatNepodporovan': 'Unsupported file type',
  'zpr.mediaOdeslano': 'Media sent',
  'zpr.mikrofon': 'The microphone is not available',
  'zpr.hlasovkaOdeslana': 'Voice message sent',
  'zpr.hlasovkaChyba': (p) => `Sending the voice message failed: ${p.detail}`,
  'zpr.smazano': 'Conversation deleted',
  'zpr.smazaniChyba': 'The conversation could not be deleted',
  'zpr.smazaniPotvrzeni': 'It disappears from your list, attachments included. The other person keeps their copy \u2014 '
      + 'the message is fully deleted from the server only once both of you delete it.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Please enter your password.',
  'sif.zapnuto': 'Encryption is on.',
  'sif.odemceno': 'Your messages are unlocked.',
  'sif.hesloNesedi': 'That password is not right.',
  'sif.prohlizecNeumi': 'This browser does not support the encryption Bloom uses. You can still write messages, '
      + 'but they will not be end-to-end encrypted.',
  'sif.noveJsouSifrovane': 'New messages are encrypted. Only you hold the key \u2014 the server cannot read them.',
  'sif.odemkniZpravy': 'Unlock your messages',
  'sif.odemkniPopis': 'The key lives only in this tab\u2019s memory, so after a page reload you need the password again. '
      + 'We cannot store it anywhere \u2014 then it would not be encryption only you control.',
  'sif.zapniSifrovani': 'Turn on message encryption',
  'sif.zapniPopis': 'New messages are encrypted right here on your device. The server receives only gibberish '
      + 'and cannot read them \u2014 not even if a court asked for them.',
  'sif.pozorA': 'Careful: the key is unlocked by your password.',
  'sif.pozorTucne': 'If you forget it, nobody can read your encrypted messages',
  'sif.pozorB': ' \u2014 not even us. That is the whole point, but it means you need somewhere to keep it.',
  'sif.mobilA': 'Turning it on also changes how you sign in: your password stops reaching the server entirely, only its hash is sent.',
  'sif.mobilTucne': 'The older Bloom mobile app will then not be able to sign in to this account',
  'sif.mobilB': ' until we update it. Everything keeps working on the web.',
  'sif.zapnoutSifrovani': 'Turn on encryption',
  'sif.odemknout': 'Unlock',
  'sif.tvojeHeslo': 'Your Bloom password',
  'sif.prilohaZamcena': 'Encrypted attachment \u2014 unlock your messages above.',
  'sif.prilohaChyba': 'The attachment could not be opened.',
  'sif.priloha': 'Message attachment',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Your location',
  'okoli.nastavtePolohu': 'Set your location to get results tailored to you',
  'okoli.vyberteVyse': 'Pick a location above to see offers and professionals near you',
  'okoli.zadniOdbornici': 'No professionals are registered in this area yet',
  'okoli.zadneNabidky': 'There are no offers in this area yet',
  'okoli.zadniClenove': 'There are no community members in this area yet',
  'okoli.vytvoritNabidku': 'Create an offer',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Searching:',
  'hled.vysledkyPro': 'Search results for:',
  'hled.nicPro': 'We found nothing for:',
  'hled.nicZkuste': 'We found nothing. Try a different word.',
  'hled.zkratte': 'Try a shorter phrase or a different keyword.',
  'hled.zadejte': 'Type what you are looking for and press Enter',
  'hled.priklady': 'For example: FFS, hormones, name, doctor, ID, surgery\u2026',
  'hled.uzivatele': 'Members',
  'hled.odbornici': 'Trans-friendly professionals',
  'hled.clanky': 'Legal help \u2013 articles',
  'hled.otazky': 'Community questions',
  'hled.nabidky': 'Offers of help',
  'hled.prispevky': 'Posts',
  'hled.recenze': 'Reviews of professionals',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Member not found',
  'up.oMne': 'About',
  'up.clenOd': 'Member since',
  'up.odznakSpravce': 'Administrator',
  'up.odznakPravnik': 'Lawyer',
  'up.odznakOdbornik': 'Verified professional',
  'up.odznakPravnikOvereny': 'Verified lawyer',
  'up.odznakClen': 'Verified member',
  'up.odznakPomocnik': 'Active helper',
  'up.odznakDuveryhodny': 'Trusted',

  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Back to Bloom',
  'kom.oProjektu': 'Bloom was created as a safe community space for trans people in the Czech Republic \u2013 a place '
      + 'to share experience, find support, connect with professionals and meet others. '
      + 'The project is run by the community on a voluntary basis. Its aims are discretion, privacy and mutual help.',
  'kom.kontaktText': 'Questions, or need help? Do get in touch. We try to reply as quickly as we can.',
  'kom.respekt': 'We respect each other',
  'kom.respektPopis': 'We address everyone by the name and pronouns they use. We respect different paths and experiences '
      + '\u2013 there is no right or wrong way to be trans.',
  'kom.soukromi': 'We protect each other\u2019s privacy',
  'kom.soukromiPopis': 'What is shared in Bloom stays in Bloom. Do not share information about other members without '
      + 'their consent. We respect anonymity.',
  'kom.pomahame': 'We help each other',
  'kom.pomahamePopis': 'Bloom is about mutual support. We share experience, help one another and build a safe space '
      + 'for everyone looking for connection or information.',
  'kom.obtezovani': 'We do not tolerate harassment',
  'kom.obtezovaniPopis': 'Harassment, bullying or hostile comments have no place in Bloom. If you feel uncomfortable, '
      + 'contact an administrator.',
  'kom.spam': 'No spam or advertising',
  'kom.spamPopis': 'Bloom is not a marketplace. Do not post unsolicited advertising or commercial content. '
      + 'Offers and requests belong in Peer support.',
  'kom.prostor': 'A space for every stage',
  'kom.prostorPopis': 'You are not alone, whatever stage of your journey you are at. We welcome people considering '
      + 'transition, in the middle of it and past it \u2013 and we take every path as it is.',
  'kom.dataPopis': 'Bloom collects only the data the platform needs to work: your email, nickname and the profile '
      + 'you create yourself.',
  'kom.dataTretiStrany': 'Your data is not shared with third parties. The platform uses no tracking technology and no ad networks.',
  'kom.dataSmazani': 'You have the right to ask for your account and all data linked to it to be deleted. Contact an administrator.',

  'okoli.podtitulek': 'Find community members, services and professionals near you',
  'okoli.cleneVOkoli': (p) => `Community members near ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Offers of help near ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Professionals near ${p.misto}`,
  'hled.zobrazitVice': 'Show more',
  'kom.titulek': 'Community guidelines',
  'kom.podtitulek': 'A safe space for everyone',
  'kom.jakNahlasit': 'How to report a problem',
  'kom.jakNahlasitPopis': 'If you come across inappropriate behaviour, you have two options: use the \u201cReport member\u201d button '
      + 'on their profile, or write to an administrator.',
  'kom.duverne': 'Your report is confidential.',
  'kom.ochranaSoukromi': 'Privacy',
  'obecne.zpetKratce': 'Back',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Nobody else in the community shares this stage publicly yet.',
  'cesta.poznamkaFazePriklad': 'Anything you want to share or remember about this stage\u2026',
  'pruvodce.fazeNenalezena': 'Stage not found',
  'pruvodce.pripravujeme': 'We are still working on this part.',
  'pruvodce.krokyJenTy': 'Only you can see the steps you tick off.',
  'pruvodce.nastavitFazi': 'Set as my current stage',
  'pruvodce.fazeNastavena': 'Set as your current stage',
  'pruvodce.chyba': 'Could not save, please try again',
  'pruvodce.kroku': 'steps',
  'pruvodce.odborniku': (p) => `${p.pocet === 1 ? 'professional' : 'professionals'} for this stage`,
  'pruvodce.pribehu': (p) => `${p.pocet === 1 ? 'story' : 'stories'} from people at this stage`,

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Password reset',
  'reset.popis': 'Enter a new password for your Bloom account.',
  'reset.noveHeslo': 'New password',
  'reset.noveHesloPriklad': 'Enter a new password',
  'reset.potvrdit': 'Confirm the new password',
  'reset.nastavit': 'Set new password',
  'reset.ukladam': 'Saving\u2026',
  'reset.hotovo': 'Your password has been changed. You can sign in now.',
  'reset.neplatnyOdkaz': 'That password reset link is not valid.',
  'reset.odkazVyprsel': 'The reset link has expired or is invalid. Please request a new one.',
  'reset.chyba': 'The password could not be reset.',
  'reset.neshoda': 'The passwords do not match.',
  'reset.ztratiPristup': 'will lose access',

  'cesta.volitelne': 'This is entirely optional. Share your transition stage if you want \u2013 or keep it to yourself. '
      + 'You can also find people at a similar point in their journey.',
  'cesta.hledatVeFazi': 'Find people at this stage:',
  'cesta.jenVerejne': '(only members who share publicly)',
  'pruvodce.zpetNaCestu': 'Back to My journey',
  'pruvodce.tadyJsi': 'You are here now',
  'reset.prejitNaPrihlaseni': 'Go to sign-in',
  'reset.sifrovaniVarovani': 'If you have message encryption on: resetting your password means you will no longer reach your old '
      + 'encrypted messages. Their key is unlocked by the original password, and nobody here knows it, so it '
      + 'cannot be re-wrapped. New messages can still be encrypted; the old ones cannot be read \u2014 not even by us.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Sign in',
  'uvod.vytvoritUcet': 'Create an account',
  'uvod.uzMamUcet': 'I already have an account',
  'uvod.nadpis': 'A safe space for the trans community',
  'uvod.podnadpis': 'Bloom is a private place where you can speak openly, find trans-friendly professionals '
      + 'and go through transition among people who know what it is like.',
  'uvod.zdarma': 'Signing up is free. Bloom\u2019s content opens only after you sign in.',
  'uvod.kCemuJe': 'What Bloom is for',
  'uvod.kCemuJe1': 'Looking for information about transition in Czechia usually means clicking through scattered '
      + 'forums, outdated articles and links you cannot tell whether to trust. And many questions are '
      + 'best answered by someone who has been through it.',
  'uvod.kCemuJe2': 'Bloom brings it all to one place: professionals the community has good experience with, a guide '
      + 'through the stages of transition, legal help, and above all people you can write to.',
  'uvod.kCemuJe3': 'And because these are things nobody wants to tell the whole internet, Bloom has been built from '
      + 'the start so that nothing at all is visible from the outside.',
  'uvod.coNajdes': 'What you will find in Bloom',
  'uvod.coNajdesPopis': 'Eight parts that build on each other \u2014 from practical help to shared experience.',
  'uvod.soukromiZaklad': 'Privacy is not an add-on, it is the foundation',
  'uvod.jakZabezpeceny': 'How Bloom is secured',
  'uvod.zabezpeceniPopis': 'Members\u2019 data is never sold or analysed. Bloom runs no advertising or analytics tracking '
      + '\u2014 no third-party script learns anything about you.',
  'uvod.coNeumi': 'What Bloom cannot do',
  'uvod.metadataTucne': 'who wrote to whom and when',
  'uvod.coNeumiA': 'The server always knows',
  'uvod.coNeumiB': ' \u2014 without that it could not deliver the message. End-to-end encryption does not hide this '
      + 'metadata, and neither does Signal. Profiles cannot be encrypted, because the server has to show '
      + 'them to others. And because Bloom is a web app, it downloads its encryption code from our server '
      + 'every time you open it \u2014 anyone who took over the server could in theory serve a modified one. '
      + 'Only a signed app from a store protects against that.',
  'uvod.pridejSe': 'Join us',
  'uvod.pridejSePopis': 'A nickname and an email are enough \u2014 you never have to give your legal name. What you write '
      + 'about yourself is up to you and you can change or delete it at any time.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Offer help or ask for it \u2014 from going along to an appointment, to lending clothes, to '
      + '\u201cI need to talk to someone\u201d.',
  'uvod.karta.odbornici': 'Sexologists, endocrinologists, surgeons, psychotherapists and hairdressers. With a map, contacts and other people\u2019s experience.',
  'uvod.karta.pravo': 'Name change, official documents, work, school. Answered by people who know the ground.',
  'uvod.karta.pruvodce': 'What each step involves \u2014 from the first questions to surgery. With links to verified sources and professionals.',
  'uvod.karta.zpravy': 'Write to anyone in the community. Messages and attachments are stored encrypted on the server.',
  'uvod.karta.zkusenosti': 'Real stories from people who have been through it. Uncensored and unvarnished.',
  'uvod.karta.aktuality': 'What is happening around trans issues in Czechia \u2014 legal changes, events, community news.',
  'uvod.karta.okoli': 'Who is near you. So you know you are not alone, even in a smaller town.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Nothing at all is visible from outside',
  'uvod.bezp.zvencinicText': 'Profiles, stories, photos, offers and post images all require signing in. Without an account the '
      + 'server hands out no information about members \u2014 not even to search engines.',
  'uvod.bezp.hesla': 'Nobody knows your password',
  'uvod.bezp.heslaText': 'Only a bcrypt hash is stored, and the original password cannot be computed from it. Not even the '
      + 'administrator can see your password or send it to you \u2014 she can only let you set a new one.',
  'uvod.bezp.sifrovani': 'Messages encrypted from you to them',
  'uvod.bezp.sifrovaniText': 'When you turn on end-to-end encryption, text and attachments are encrypted in your own browser. '
      + 'The key is unlocked by your password and never leaves your device \u2014 the server gets only '
      + 'gibberish and cannot read it, not even if a court asked. Without encryption, messages are at least '
      + 'encrypted on the server\u2019s disk.',
  'uvod.bezp.kontakty': 'Your contact details stay yours',
  'uvod.bezp.kontaktyText': 'Your email and phone are never returned to other members. Your transition stage is private until '
      + 'you publish it yourself \u2014 and the steps you tick off in the Guide are visible only to you.',
  'uvod.bezp.smazane': 'Deleted really means deleted',
  'uvod.bezp.smazaneText': 'You can delete a conversation at any time. Once both sides delete it, it disappears from the server '
      + 'for good, attachments included.',
  'uvod.bezp.server': 'Our own server in Europe',
  'uvod.bezp.serverText': 'Bloom runs on its own server in the European Union, over HTTPS only. The database is not reachable '
      + 'from the internet. Backups leave encrypted to separate storage and restoring them has been tested.',

  'uvod.karta.pruvodceNazev': 'Guide through transition',
  'uvod.karta.zpravyNazev': 'Private messages',

  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Offer your skills and get help from other community members',
  'pod.vse': 'All',
  'pod.nabidky': 'Offers',
  'pod.poptavky': 'Requests',
  'pod.nabidka': 'Offer',
  'pod.poptavka': 'Request',
  'pod.celaCR': 'All of Czechia',
  'pod.celySvet': 'The whole world',
  'pod.cesko': 'Czechia',
  'pod.svet': 'World',
  'pod.vsechnyTypy': 'All categories',
  'pod.moje': (p) => `Mine (${p.pocet})`,
  'pod.pridat': 'Add',
  'pod.overEmail': 'Verify your email to add an offer',
  'pod.novaPoptavka': 'New request',
  'pod.novaNabidka': 'New offer',
  'pod.popisPoptavky': 'Write what you are looking for and what you offer in return.',
  'pod.popisNabidky': 'Offer your skills to other community members.',
  'pod.typPrispevku': 'Post type',
  'pod.volitelne': '(optional)',
  'pod.coNabizim': 'What I offer',
  'pod.coNabizimP': 'What I offer *',
  'pod.coHledamP': 'What I am looking for *',
  'pod.coHledamVymenou': 'What I want in return',
  'pod.priklOffer': 'e.g. cooking, haircuts, translation\u2026',
  'pod.priklNeed': 'e.g. massages, photography\u2026',
  'pod.poptavkaSeZobrazi': 'Your request will appear in the Requests tab.',
  'pod.nabidkaSeZobrazi': 'If you fill this in, your offer will also appear in the Requests tab.',
  'pod.popis': 'Description',
  'pod.popisPriklad': 'A more detailed description\u2026',
  'pod.oblast': 'Area',
  'pod.lokalita': 'Location',
  'pod.nechciUvadet': 'Rather not say',
  'pod.kategorie': 'Category',
  'pod.ostatni': 'Other',
  'pod.pridatPoptavku': 'Add request',
  'pod.pridatNabidku': 'Add offer',
  'pod.odpovedetNaPrispevek': 'Reply to a post',
  'pod.napisteAutorovi': 'Send the author a private message.',
  'pod.od': (p) => `From: ${p.kdo}`,
  'pod.odeslatZpravu': 'Send message',
  'pod.konceptOdpovedi': (p) => `Hello! I am interested in your ${p.co} \u201c${p.nazev}\u201d. `,
  'pod.konceptPoptavka': 'request',
  'pod.konceptNabidka': 'offer',
  'pod.zadneMoje': 'You have no posts yet',
  'pod.zadneNalezeny': 'No posts found',
  'pod.vytvortePrvni': 'Create your first offer or request',
  'pod.zkusteFiltry': 'Try changing the filters or add a new post',
  'pod.expirovano': 'Expired',
  'pod.hledam': 'Looking for',
  'pod.hledamCo': (p) => `Looking for: ${p.co}`,
  'pod.nabizimCo': (p) => `Offering: ${p.co}`,
  'pod.expirovala': 'This offer has expired. Contact an administrator to renew it.',
  'pod.odpovedet': 'Reply',
  'pod.upravitPrispevek': 'Edit post',
  'pod.upravtePrispevek': 'Edit your offer or request.',
  'pod.nabizimP': 'I offer *',
  'pod.hledamPotrebuji': 'Looking for / need',
  'pod.coNabizitePriklad': 'What do you offer\u2026',
  'pod.coHledatePriklad': 'What are you looking for\u2026',
  'pod.ulozitZmeny': 'Save changes',
  'pod.vytvorenoPoptavka': 'Request created.',
  'pod.vytvorenoNabidka': 'Offer created.',
  'pod.chybaVytvorit': 'The post could not be created',
  'pod.opravduSmazat': 'Delete this offer?',
  'pod.smazano': 'Deleted',
  'pod.chybaSmazat': 'It could not be deleted',
  'pod.aktualizovano': 'Post updated.',
  'pod.chybaUlozit': 'It could not be saved',
  'pod.zpravaOdeslana': 'Message sent.',
  'pod.chybaOdeslat': 'The message could not be sent',
  'obecne.hledatPriklad': 'Search\u2026',
  'obecne.upravit': 'Edit',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Find verified professionals who can help you on your way',
  'odb.hledatPriklad': 'Search by name or city\u2026',
  'odb.vsechnyObory': 'All fields',
  'odb.radit': 'Sort:',
  'odb.vychozi': 'Default',
  'odb.nejvyssiHodnoceni': '\u2605 Highest rated',
  'odb.nejnizsiHodnoceni': '\u2605 Lowest rated',
  'odb.zadniNalezeni': 'No professionals found',
  'odb.zkusteFiltry': 'Try changing the filters',
  'odb.recenzi': (p) => (p.pocet === 1 ? 'review' : 'reviews'),
  'odb.dostupnyV': 'Available in:',
  'odb.otevritVMapach': 'Open in maps',
  'odb.pridatRecenzi': 'Add a review',
  'odb.ohodnotte': 'Rate your experience with this professional.',
  'odb.vaseHodnoceni': 'Your rating *',
  'odb.popisZkusenosti': 'Describe your experience',
  'odb.popisteZkusenost': 'Describe your experience\u2026',
  'odb.odeslatRecenzi': 'Send review',
  'odb.recenze': (p) => `Reviews (${p.pocet})`,
  'odb.zadneRecenze': 'No reviews yet. Be the first.',
  'odb.vyberteOdbornika': 'Pick a professional to see their details and the map',
  'odb.pridatOdbornika': 'Add a professional',
  'odb.pridejteOdbornika': 'Add a new verified professional to the list.',
  'odb.navrhnout': 'Suggest a professional',
  'odb.navrhnetePopis': 'Suggest a professional for administrators to approve.',
  'odb.navrhVysvetleni': 'Your suggestion will be sent to the administrators. Once approved, it will appear in the list.',
  'odb.overEmail': 'Verify your email to suggest a professional',
  'odb.jmeno': 'Name *',
  'odb.kategorie': 'Category *',
  'odb.popis': 'Description',
  'odb.popisPriklad': 'Specialisation, experience\u2026',
  'odb.adresa': 'Address *',
  'odb.mesto': 'City *',
  'odb.kraj': 'Region',
  'odb.vyber': 'Choose',
  'odb.stat': 'Country',
  'odb.cesko': 'Czechia',
  'odb.telefon': 'Phone',
  'odb.web': 'Website',
  'odb.odesilam': 'Sending\u2026',
  'odb.odeslatKeSchvaleni': 'Send for approval',
  'odb.recenzePridana': 'Review added.',
  'odb.chybaRecenze': 'The review could not be added',
  'odb.odeslanKeSchvaleni': 'The professional was sent for approval.',
  'odb.chybaOdeslat': 'The professional could not be sent',
  'odb.pridan': 'Professional added.',
  'odb.chybaPridat': 'It could not be added',
  'odb.polozitOtazku': 'Ask a question',
  'odb.novaOtazka': 'New question for professionals',
  'odb.naCoSeZeptat': 'What would you like to ask the professionals?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Information and support for the trans community',
  'prav.zpetNaPoradnu': 'Back to Legal help',
  'prav.clankyAPruvodci': 'Articles and guides',
  'prav.pridatClanek': 'Add an article',
  'prav.novyClanek': 'New article',
  'prav.vytvorteClanek': 'Write a new article for the legal section.',
  'prav.nazev': 'Title *',
  'prav.kategorie': 'Category',
  'prav.publikovatIhned': 'Publish right away',
  'prav.publikovano': 'Published',
  'prav.obsah': 'Content *',
  'prav.obsahPriklad': 'Article content\u2026',
  'prav.zadneClanky': 'No articles in this category',
  'prav.skryto': 'Hidden',
  'prav.skryt': 'Hide',
  'prav.publikovat': 'Publish',
  'prav.upravitClanek': 'Edit article',
  'prav.upravteObsah': 'Edit the content of this article.',
  'prav.clanekPridan': 'Article added.',
  'prav.chybaPridat': 'The article could not be added',
  'prav.clanekUpraven': 'Article updated.',
  'prav.opravduSmazat': 'Delete this article?',
  'prav.chybaStav': 'The status could not be changed',
  'prav.pridatOtazku': 'Add a question',
  'prav.novaOtazka': 'New question',
  'prav.naCoSeZeptat': 'What would you like to ask?',
  'obecne.vse': 'All',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'News from the trans world',
  'akt.prehratVideo': 'Play video',
  'akt.obrazekVClanku': 'Image in the article',
  'akt.clanekNenalezen': 'Article not found',
  'akt.zpetNaAktuality': 'Back to news',
  'akt.autor': (p) => `Author: ${p.kdo}`,
  'akt.osobniPribeh': 'Personal story',
  'akt.upravitClanek': 'Edit article',
  'akt.komentare': (p) => `Comments (${p.pocet})`,
  'akt.zadneKomentare': 'No comments yet. Be the first.',
  'akt.pridatKomentar': 'Add a comment\u2026',
  'akt.proKomentovaniOverte': 'Verify your email to comment.',
  'akt.profil': 'Profile',
  'akt.prihlasteSeProKomentovani': 'Sign in to comment.',
  'akt.upravteObsah': 'Edit the content of this article.',
  'akt.nadpisP': 'Headline *',
  'akt.nadpis': 'Headline',
  'akt.obsahP': 'Content *',
  'akt.textClanku': 'Article text\u2026',
  'akt.obrazekUrlNeboSoubor': 'Image (URL or file)',
  'akt.videoUrlNeboSoubor': 'Video (URL or file)',
  'akt.ukladam': 'Saving\u2026',
  'akt.novaAktualita': 'New article',
  'akt.sdiletPribeh': 'Share a story',
  'akt.vytvoritAktualitu': 'Write an article',
  'akt.sdiletZkusenost': 'Share an experience',
  'akt.napisteAktualitu': 'Write a new article for the community.',
  'akt.podelteSe': 'Share your experience with the community.',
  'akt.obrazek': 'Image',
  'akt.nahratObrazek': 'Upload an image\u2026',
  'akt.nahratVideo': 'Upload a video\u2026',
  'akt.neboUrl': 'or a URL:',
  'akt.textAktuality': 'Article text\u2026',
  'akt.sdilejtePribeh': 'Share your story or experience with the community\u2026',
  'akt.nahravam': 'Uploading\u2026',
  'akt.publikovat': 'Publish',
  'akt.zkusenostiTucne': 'Personal experiences of community members.',
  'akt.zkusenostiPopis': 'This section is for sharing life experiences and stories. Posts may include text, images or video.',
  'akt.sdiletSvujPribeh': 'Share your story',
  'akt.zadneAktuality': 'No news',
  'akt.zadneVKategorii': 'There is nothing in this category yet',
  'akt.publikovan': 'Post published.',
  'akt.chybaPublikovat': 'It could not be published',
  'akt.opravduSmazat': 'Delete this post?',
  'akt.chyba': 'Something went wrong',
  'akt.chybaKomentar': 'The comment could not be added',
  'akt.chybaSmazatKomentar': 'The comment could not be deleted',
  'akt.aktualizovan': 'Post updated.',
  'obecne.smazat': 'Delete',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Thinking about transition',
  'faze.thinking.popis': 'I am working out who I am and which path is mine.',
  'faze.research': 'Looking for information',
  'faze.research.popis': 'Reading, asking, looking for sources and community.',
  'faze.therapist': 'First visit to a therapist',
  'faze.therapist.popis': 'Talking to a professional about my path.',
  'faze.hormones': 'Hormone therapy',
  'faze.hormones.popis': 'Starting or continuing hormone therapy.',
  'faze.documents': 'Changing documents',
  'faze.documents.popis': 'Working on the legal change of name or gender.',
  'faze.cosmetic': 'Appearance and grooming',
  'faze.cosmetic.popis': 'Working on how I look \u2013 hair, make-up, style.',
  'faze.surgery-thinking': 'Considering surgery',
  'faze.surgery-thinking.popis': 'Thinking through the surgical options.',
  'faze.surgery': 'After surgery',
  'faze.surgery.popis': 'I have had one or more surgeries.',
  'faze.stable': 'Settled',
  'faze.stable.popis': 'I am where I want to be and living my life.',
  'faze.individual': 'My own path',
  'faze.individual.popis': 'My path does not fit any box \u2013 and that is fine.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'This is where stories are shared.',
  'zk.pribehNenalezen': 'Story not found',
  'zk.zpetNaPribehy': 'Back to stories',
  'zk.komunita': 'The community',
  'zk.pribeh': 'Story',
  'zk.upravitPribeh': 'Edit story',
  'zk.upravtePribeh': 'Edit the story you shared.',
  'zk.textPribehu': 'Story text\u2026',
  'zk.fazeTranzice': 'Transition stage',
  'zk.neuvadet': 'Not saying',
  'zk.ukazeSeLidem': 'The story will be shown to people reading the guide for that stage.',
  'zk.sdiletPribeh': 'Share a story',
  'zk.overEmail': 'Verify your email to share a story',
  'zk.zadnePribehy': 'No stories yet. Be the first.',
  'zk.nazevPribehu': 'The title of your story\u2026',
  'zk.pribehP': 'Story *',
  'zk.sdilejteZkusenost': 'Share your experience with the community\u2026',
  'zk.chybaNacist': 'The stories could not be loaded',
  'zk.vyplnteNadpis': 'Fill in the headline and the text',
  'zk.spatnyOdkaz': 'An image link has to start with http://, https:// or /',
  'zk.sdilen': 'Story shared.',
  'zk.chybaSdilet': 'It could not be shared',
  'zk.opravduSmazat': 'Delete this story?',
  'zk.smazan': 'Story deleted',
  'zk.aktualizovan': 'Story updated.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Your email is not verified yet. Please confirm it.',
  'ram.odesilam': 'Sending\u2026',
  'ram.znovuOdeslat': 'Send again',
  'ram.chceteUpozorneni': 'Would you like alerts for new messages?',
  'ram.tedNe': 'Not now',
  'ram.paticka': '\u00a9 2026 Bloom \u2013 a private space for the trans community',
  'ram.zasadyKomunity': 'Community guidelines',
  'ram.nahlasitProblem': 'Report a problem',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Administrator',
  'ot.overenyPravnik': 'Verified lawyer',
  'ot.overenyOdbornik': 'Verified professional',
  'ot.odznakJinaZeme': (p) => `This badge applies only to: ${p.zeme}`,
  'ot.otazkyKomunity': 'Community questions',
  'ot.pridatOtazku': 'Add a question',
  'ot.novaOtazka': 'New question',
  'ot.naCoSeZeptat': 'What would you like to ask?',
  'ot.otazkaSeZobrazi': 'Your question will be shown to other members, who can answer it.',
  'ot.otazkaP': 'Question *',
  'ot.oblastTema': 'Area / topic',
  'ot.vseObecna': 'Anything (a general question)',
  'ot.odeslatOtazku': 'Send question',
  'ot.overEmail': 'Verify your email to add a question',
  'ot.zadneOtazky': 'No questions yet. Be the first.',
  'ot.hlasu': (p) => (p.pocet === 1 ? 'vote' : 'votes'),
  'ot.odpovedi': (p) => (p.pocet === 1 ? 'answer' : 'answers'),
  'ot.zadneOdpovedi': 'No answers yet.',
  'ot.napisteOdpoved': 'Write an answer\u2026',
  'ot.jenPravnici': 'Questions in Legal help are answered by verified lawyers and administrators.',
  'ot.smazatOtazku': 'Delete this question?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Offers and requests',
  'cp.zadneNabidky': 'No offers',
  'cp.napsatZpravu': 'Send a message',
  'cp.nahlasitUzivatele': 'Report member',
  'cp.nahlasitKoho': (p) => `Report ${p.kdo}`,
  'cp.popisteDuvod': 'Describe why you are reporting this. Administrators will see the report.',
  'cp.zustaneteAnonymni': 'An administrator receives the report. You stay anonymous.',
  'cp.duvodP': 'Reason *',
  'cp.vybertDuvod': 'Pick a reason\u2026',
  'cp.nevhodneChovani': 'Inappropriate behaviour',
  'cp.falesnyProfil': 'Fake profile',
  'cp.jinyProblem': 'Another problem',
  'cp.popisVolitelny': 'Description',
  'cp.volitelny': '(optional)',
  'cp.popisteSituaci': 'Describe the situation in more detail\u2026',
  'cp.odeslatNahlaseni': 'Send report',
  'cp.vyberteDuvodChyba': 'Pick a reason for the report',
  'cp.nahlaseniOdeslano': 'The report has been sent to an administrator',
  'cp.chybaNahlaseni': 'The report could not be sent',
  'gal.chranenoHeslem': 'Password protected',
  'gal.soukromi': 'Privacy',
  'gal.nahravam': 'Uploading\u2026',
  'gal.pridatFotku': 'Add a photo',
  'gal.nastaveniSoukromi': 'Gallery privacy settings',
  'gal.verejna': 'Public',
  'gal.chranenaHeslem': 'Password protected',
  'gal.jeChranena': 'This gallery is password protected',
  'gal.zadneFotky': 'No photos yet. Add your first one.',
  'gal.otagovat': 'Tag a member',
  'gal.hledatUzivatele': 'Search for a member\u2026',
  'gal.odemcena': 'Gallery unlocked',
  'gal.spatneHeslo': 'Wrong gallery password',
  'gal.nastaveniUlozeno': 'Gallery settings saved',
  'gal.fotkaNahrana': 'Photo uploaded.',
  'gal.chybaNahrat': 'The photo could not be uploaded',
  'gal.fotkaSmazana': 'Photo deleted',
  'gal.jizOtagovan': 'That member is already tagged',
  'gal.otagovan': (p) => `Tagged: ${p.kdo}`,
  'gal.chybaTag': 'The tag could not be added',

  'ram.povolit': 'Allow',
  'ram.oProjektu': 'About',
  'ram.prekladNeovereny': 'Nobody who speaks this language has read this translation yet. If something sounds off, tell us.',
  'ram.kontakt': 'Contact',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'World map \u2013 click a country to open it',
  'mapa.priblizit': 'Zoom in',
  'mapa.oddalit': 'Zoom out',
  'mapa.celySvet': 'Back to the whole world',
  'mapa.chybaNacteni': 'The map could not be loaded',
  'mapa.chybaZkusteSeznam': 'The map could not be loaded. Try the list of countries below.',
  'mapa.teprveRoste': 'Bloom is only starting here',
  'mapa.napovedaDotyk': 'Drag to move the map; pinch, double-tap or use the buttons to zoom. You do not have to use it — search and the full list of countries are below.',
  'obsah.specialists': (p) => (p.pocet === 1 ? 'professional' : 'professionals'),
  'obsah.organizations': (p) => (p.pocet === 1 ? 'organisation' : 'organisations'),
  'obsah.events': (p) => (p.pocet === 1 ? 'event' : 'events'),
  'obsah.pageants': (p) => (p.pocet === 1 ? 'pageant' : 'pageants'),
  'obsah.resources': (p) => (p.pocet === 1 ? 'resource' : 'resources'),
  'obsah.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entry' : 'entries'}`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Where is home for you?',
  'domov.popis': 'Bloom will then show you what is close to you. You can browse any country \u2014 that will not change '
      + 'your home country. It is never made public and you can change it any time.',
  'domov.preskocit': 'Skip',
  'domov.najitZemi': 'Find a country\u2026',
  'domov.nicNeodpovida': 'Nothing matches. Try a different search.',
  'domov.klikniDoMapy': 'You can also just click a country on the map above.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Post',
  'typ.users': 'Member',
  'typ.specialists': 'Professional',
  'typ.services': 'Offer',
  'typ.articles': 'Legal help',
  'typ.questions': 'Community question',
  'typ.reviews': 'Review of a professional',
  'nav.emailNeoveren': 'Email not verified',
  'nav.neovereny': 'Not verified',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Something is broken',
  'chyba.navrh': 'A suggestion',
  'chyba.bezpecnost': 'A security problem',
  'chyba.jiny': 'Something else',
  'chyba.vyberteTyp': 'Please pick the kind of problem',
  'chyba.popisteProsim': 'Please describe the problem',
  'chyba.odeslano': 'Report sent, thank you.',
  'chyba.chybaOdeslat': 'The report could not be sent',
  'chyba.napisteNam': 'Tell us what happened \u2014 it helps us fix it.',
  'chyba.typProblemu': 'Kind of problem',
  'chyba.popisProblemu': 'What happened',
  'chyba.popisPriklad': 'Describe what happened, what you expected and what happened instead\u2026',
  'chyba.priloha': 'We attach automatically: the current page, the time and information about your browser.',
  'chyba.odeslatHlaseni': 'Send report',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Write the content\u2026',
  'ed.tucne': 'Bold (Ctrl+B)',
  'ed.kurziva': 'Italic (Ctrl+I)',
  'ed.odrazky': 'Bulleted list',
  'ed.vlozitOdkaz': 'Insert a link',
  'ed.vlozitTabulku': 'Insert a table',
  'ed.radky': 'Rows',
  'ed.sloupce': 'Columns',
  'ed.vlozit': 'Insert',
  'ed.barva.cerna': 'Black',
  'ed.barva.seda': 'Grey',
  'ed.barva.fialova': 'Purple',
  'ed.barva.ruzova': 'Pink',
  'ed.barva.modra': 'Blue',
  'ed.barva.zelena': 'Green',
  'ed.barva.cervena': 'Red',
  'ed.barva.oranzova': 'Orange',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'That verification link is not valid.',
  'over.hotovo': 'Your email is verified.',
  'over.odkazVyprsel': 'The verification link is invalid or has expired.',
  'over.overuji': 'Verifying your email\u2026',
  'over.cekejte': 'Please wait.',
  'over.overen': 'Email verified.',
  'over.plnyPristup': 'You now have full access to everything in Bloom.',
  'over.prejitNaBloom': 'Go to Bloom',
  'over.selhalo': 'Verification failed',
  'over.zpetNaPrihlaseni': 'Back to sign-in',
  'oauth.ucetNenalezen': 'Account not found',
  'oauth.neexistujeGoogle': 'There is no Bloom account for this Google account. Please sign up first.',
  'oauth.neexistujeFacebook': 'There is no Bloom account for this Facebook account. Please sign up first.',
  'oauth.registrovatGoogle': 'Sign up with Google',
  'oauth.registrovatFacebook': 'Sign up with Facebook',
  'oauth.prihlasujiGoogle': 'Signing in with Google\u2026',
  'oauth.prihlasujiFacebook': 'Signing in with Facebook\u2026',
  'oauth.facebookSelhalo': 'Signing in with Facebook failed',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Loading\u2026',
  'obecne.nezadano': '\u2014 not set \u2014',
  'obecne.neplatnaHodnota': 'That value is not valid.',
  'obecne.strankovani': 'Pagination',
  'navrh.doplnteNazev': 'Please fill in the name.',
  'navrh.vyberteZemi': 'Please pick a country.',
  'navrh.doplnte': (p) => `Please fill in: ${p.co}.`,
  'kat.overenoZaznam': 'Checked that this entry matches reality',
  'kat.prihlaskyDo': (p) => `Applications until ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Profile',
  'profil.zalozkaGalerie': 'Gallery',
  'pf.lokalita': 'Location',

  'cesta.legendaBarev': 'Colour key',

  'hled.pocetVysledku': (p) => `(${p.pocet} ${p.pocet === 1 ? 'result' : 'results'})`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Long blonde hair',
  'avatar.fem-lavender': 'Purple hair',
  'avatar.fem-peach': 'Bob with a fringe',
  'avatar.fem-dark': 'Long dark hair',
  'avatar.fem-straight': 'Red hair',
  'avatar.fem-ponytail': 'Ponytail',
  'avatar.masc-blue': 'Short blonde hair',
  'avatar.masc-teal': 'Tousled hair',
  'avatar.masc-gray': 'Grey hair',
  'avatar.masc-short': 'Buzz cut',
  'avatar.nb-mint': 'Mint hair',
  'avatar.nb-lilac': 'Top bun',
  'avatar.nb-curly': 'Short curls',
  'avatar.nb-sage': 'Shoulder-length hair',
  'avatar.nb-mohawk': 'Mohawk',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Shaved head',
  'avatar.nb-glasses': 'Glasses',
  'avatar.animal-cat': 'Cat',
  'avatar.animal-fox': 'Fox',
  'avatar.animal-rabbit': 'Rabbit',
  'avatar.sym-flower': 'Flower',
  'avatar.sym-butterfly': 'Butterfly',
  'avatar.sym-star': 'Star',
  'avatar.custom': 'Upload your own photo',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'We signed you out after a while of inactivity.',
  'odhl.necinnostPopis': 'Bloom does not leave you signed in when nobody is there.',
  'odhl.zaChvili': 'We will sign you out in a moment',
  'odhl.zaChviliPopis': 'Touch the screen or the keyboard any time and you stay signed in.',

  'reg.avatarSymboly': 'Symbols',

  'avatar.fem-bun': 'Bun',
  'avatar.masc-navy': 'Full beard',
  'avatar.masc-brown': 'Side parting',
  'avatar.masc-goatee': 'Goatee',
  'avatar.nb-freckles': 'Freckles',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Owl',
  'avatar.sym-rainbow': 'Rainbow',
  'avatar.sym-heart': 'Heart',
  'avatar.sym-lotus': 'Lotus (Bloom)',

  'reg.potvrditHeslo': 'Confirm password',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Create',
  'obecne.sdilet': 'Share',
  'obecne.opravneni': 'Permission',
  'obecne.pristupGalerie': 'We need access to your photos to upload a picture.',
  'obecne.vsechnyRegiony': 'All regions',
  'obecne.cesko': 'Czechia',
  'obecne.odbornici': 'Professionals',
  'obecne.zadnaZprava': 'No messages',
  'ucet.vyplnteEmailHeslo': 'Enter your e-mail and password',
  'ucet.spatneUdaje': 'Wrong e-mail or password',
  'ucet.googleSelhalo': 'Google sign-in failed',
  'ucet.skrytHeslo': 'Hide password',
  'ucet.emailOveren': 'Your e-mail has been verified.',
  'ucet.emailPriklad': 'you@email.com',
  'ucet.overeniSelhalo': 'Verification failed.',
  'ucet.overeniSelhaloZnovu': 'Verification failed. Please try again.',
  'ucet.komunitniHesloPovinne': 'The community password is required',
  'ucet.zadejteKomunitniHeslo': 'Enter the community password…',
  'ucet.komunitniHesloPopis': 'Bloom is a private space. Someone from the community can give you the password.',
  'ucet.prezdivkaMin3': 'Your display name must be at least 3 characters',
  'ucet.vyplntePrezdivku': 'Enter a display name',
  'ucet.vasePrezdivka': 'Your display name',
  'ucet.profilNeulozen': 'Could not save your profile',
  'ucet.anoZrusitProfil': 'Yes, delete my profile',
  'heslo.min8': 'Password must be at least 8 characters',
  'heslo.maleP': 'Password must contain a lowercase letter',
  'heslo.velkeP': 'Password must contain an uppercase letter',
  'heslo.cislo': 'Password must contain a number',
  'heslo.specialni': 'Password must contain a special character',
  'heslo.specialniPriklad': 'Password must contain a special character (!@#$%)',
  'heslo.napoveda': 'Min. 8 characters, uppercase, number, special',
  'profil.oSobe': 'A little about you…',
  'profil.zajmenaOna': 'she/her',
  'profil.zajmenaJine': 'other',
  'profil.doplnujiciText': 'Optional extra note…',
  'profil.prikladOboru': 'e.g. plastic surgery, family law…',
  'komunita.soukromiNadpis': 'We protect privacy',
  'komunita.soukromiText': 'What is shared in Bloom stays in Bloom.',
  'komunita.podporaText': 'Bloom is about supporting each other.',
  'komunita.neniObchod': 'Bloom is not a marketplace.',
  'komunita.zadneObtezovani': 'Harassment of any kind has no place in Bloom.',
  'komunita.oslovovani': 'We address everyone by the name and pronouns they use.',
  'komunita.jakakolivEtapa': 'Wherever you are on your journey.',
  'prav.kategZdravi': 'Health',
  'prav.kategPravni': 'Legal',
  'prav.kategSocialni': 'Social',
  'ot.chybaOdpoved': 'Could not send your answer.',
  'ot.chybaOtazka': 'Could not post your question.',
  'zk.napisteKomentar': 'Write a comment…',
  'zpr.chybaHlasova': 'Could not upload the voice message. Server:',
  'zpr.chybaObrazek': 'Could not upload the image. Server:',
  'pod.nabizim': 'Offering',
  'pod.coHledate': 'What are you looking for? (e.g. massage, photography…)',
  'pod.coNabizite': 'What are you offering? (e.g. cooking, hairstyling…)',
  'pod.lokalitaVolitelna': 'Location (optional)',
  'pod.podrobnejsiPopis': 'More detail *',
  'pod.vyplnteHledate': 'Say what you are looking for.',
  'pod.vyplnteNabizite': 'Say what you are offering.',
  'pod.vyplntePopis': 'Add a description.',
  'pod.zadnePrispevky': 'You have no posts yet. Create an offer or a request.',
  'svet.vybratZemi': 'Choose a country',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Ask a question',
  'ot.nadpis': 'Questions and answers',
  'zk.pridat': 'Add a story',
  'zk.novy': 'New story',
  'zk.smazat': 'Delete story',
  'zk.zadne': 'No stories yet. Be the first to share.',
  'akt.zadne': 'No news yet.',
  'nav.clanky': 'Articles',
  'ucet.emailOdeslan': 'E-mail sent',
  'ucet.komunitniHeslo': 'Community password',
  'ucet.nemateUcet': 'No account yet? Sign up',
  'ucet.muzetePrihlasit': 'You can sign in now.',
  'ucet.zapomenutePopis': 'Enter your e-mail and we will send you a link to reset your password.',
  'profil.oMneVolitelne': 'About me (optional)',
  'profil.prezdivka': 'Display name',
  'profil.telefonVolitelne': 'Phone (optional)',
  'cesta.poznamkaVolitelna': 'Personal note (optional)',
  'okoli.vyberteLokalitu': 'Choose a location above',
  'hled.nadpis': 'Search',
  'hled.popis': 'Search across the whole app – people, articles, stories, reviews…',
  'hled.min2': 'Type at least 2 characters to search',
  'pod.vsechnySluzby': 'All services',
  'domu.clenoveKomunity': 'Community members',
  'zpr.zadneKonverzaceHledat': 'No conversations yet. Search for someone above.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'he/him',
  'reg.zajmenaOni': 'they/them',
  'reg.zajmenaOno': 'it/its',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Delete photo',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Set a password for the gallery',
  'reg.min3znaky': 'Min. 3 characters',
  'reg.zopakujteHeslo': 'Repeat the password',
  'hled.vBloom': 'Search in Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Edit profile',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Choose a region',
  'obecne.region': 'Region',
  'gal.heslemChranena': 'Password protected',
  'gal.hesloGalerie': 'Gallery password',
  'reset.nastavitHeslo': 'Set password',
  'reset.hesloObnoveno': 'Password reset.',
  'profil.nenalezen': 'Profile not found',
  'obecne.nebo': 'or',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Open your authenticator app and copy the six digits shown for Bloom. You can enter one of your backup codes instead.',
  'auth.sifrovaniNapoveda': 'If you turned on message encryption on the web, the app cannot sign in to that account yet. Please use bloomapp.cz in a browser.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Show password',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Delete this photo?',
  'dvf.zadejteKod': 'Enter the code from your app',
  'sif.odemknoutAplikaci': 'Unlock the app',
  'profil.odeslatZnovu': 'Send again',
};

export default en;
